import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../../../store';
import type { RBACGroup } from '../../../types';

type SliceState = {
  pendingAdds: RBACGroup[];
  pendingDeletes: RBACGroup[];
  selectedGroupId: string;
};

const initialState: SliceState = {
  pendingAdds: [],
  pendingDeletes: [],
  selectedGroupId: '',
};

// RTK slice to track pending adds and deletes of Role group memberships for the currently selected ACL
export const aclMembershipSlice = createSlice({
  initialState,
  name: 'aclMembership',
  reducers: {
    addRoleToACLPendingAdds: (state, action) => {
      if (!state.pendingAdds.some((group) => group.id === action.payload.id)) {
        state.pendingAdds.push(action.payload);
      }
    },
    addRoleToACLPendingDeletes: (state, action) => {
      // If the group is in pending adds, remove it from there instead
      if (state.pendingAdds.some((group) => group.id === action.payload.id)) {
        state.pendingAdds = state.pendingAdds.filter((group) => group.id !== action.payload.id);
      } else if (!state.pendingDeletes.some((group) => group.id === action.payload.id)) {
        state.pendingDeletes.push(action.payload);
      } else {
        // Toggle off if already pending delete
        state.pendingDeletes = state.pendingDeletes.filter(
          (group) => group.id !== action.payload.id
        );
      }
    },
    clearACLPendingRoles: (state) => {
      state.pendingAdds = [];
      state.pendingDeletes = [];
      state.selectedGroupId = '';
    },
    removeRoleFromACLPendingAdds: (state, action) => {
      state.pendingAdds = state.pendingAdds.filter((group) => group.id !== action.payload.id);
    },
    removeRoleFromACLPendingDeletes: (state, action) => {
      state.pendingDeletes = state.pendingDeletes.filter((group) => group.id !== action.payload.id);
    },
    selectACLRole: (state, action) => {
      state.selectedGroupId = state.selectedGroupId === action.payload.id ? '' : action.payload.id;
    },
  },
});

export default aclMembershipSlice.reducer;

export const {
  selectACLRole,
  addRoleToACLPendingAdds,
  addRoleToACLPendingDeletes,
  removeRoleFromACLPendingAdds,
  removeRoleFromACLPendingDeletes,
  clearACLPendingRoles,
} = aclMembershipSlice.actions;

export const selectACLPendingAdds = (state: RootState) => state.aclMembership.pendingAdds;
export const selectACLPendingDeletes = (state: RootState) => state.aclMembership.pendingDeletes;
export const selectSelectedACLRoleGroupId = (state: RootState) =>
  state.aclMembership.selectedGroupId;
